import React, { useState } from "react";

const App = () => {
    const [values, setValues] = useState({ dr: 0, dmg: 0, diceDR: "0d+0" });

    const onChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            [event.target.name]: event.target.value,
        }));
    };

    const updateDiceDR = (event) => {
        event.persist();
        let floatDice = event.target.value / 3.5,
            fullDice = Math.floor(floatDice),
            diceExtra =
                floatDice % 1 > 0.75
                    ? 3
                    : floatDice % 1 > 0.5
                    ? 2
                    : floatDice % 1 > 0.25
                    ? 1
                    : 0;
        setValues((values) => ({
            ...values,
            diceDR: `${fullDice}d+${diceExtra}`,
            dr: event.target.value,
        }));
    };

    const updateDR = (event) => {
        event.persist();
        const value = event.target.value.toString(),
            fullDice = parseInt(value.substring(0, value.indexOf("d"))),
            diceExtra = parseInt(value.substring(value.indexOf("d") + 1)),
            finalDR = Math.ceil(fullDice * 3.5) + diceExtra;

        console.log(fullDice);
        setValues((values) => ({
            ...values,
            diceDR: value,
            dr: finalDR,
        }));
    };

    return (
        <div>
            <form
                style={{
                    width: "500px",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div>
                    <label htmlFor="dr">DR: </label>
                    <input
                        type="number"
                        name="dr"
                        id="dr"
                        value={values.dr}
                        onChange={updateDiceDR}
                    />
                </div>
                <div>
                    <label htmlFor="dicedr">DiceDR: </label>
                    <input
                        type="text"
                        name="dicedr"
                        id="dicedr"
                        value={values.diceDR}
                        onChange={updateDR}
                    />
                </div>
                <div>
                    <label htmlFor="dmg">DMG: </label>
                    <input
                        type="number"
                        name="dmg"
                        id="dmg"
                        value={values.dmg}
                        onChange={onChange}
                    />
                </div>

                <input type="button" onClick="" value="Calculate" />
            </form>
        </div>
    );
};

export default App;
